



















import { Vue, Component, Watch } from 'vue-property-decorator';

@Component
export default class Music extends Vue {
  isPlaying = false;

  @Watch('isPlaying')
  onPlayStatusChange(newStatus: boolean) {
    const playBtn = this.$refs.playBtn as HTMLDivElement;
    playBtn.style.animationPlayState = this.isPlaying ? 'running' : 'paused';
  }

  mounted() {
    const player = this.$refs.player as HTMLAudioElement;
    const playBtn = this.$refs.playBtn as HTMLDivElement;
    // player.removeAttribute('muted');
    player.play();
    document.addEventListener(
      'WeixinJSBridgeReady',
      () => {
        console.log('dom loaded', player);
        // player.removeAttribute('muted');
        player.play();
      },
      false,
    );
    // document.addEventListener('touchstart', () => {
    //   player.play();
    // });
    playBtn.style.animationPlayState = this.isPlaying ? 'running' : 'paused';
  }

  onPlay() {
    console.log('bgm is playing');
    this.isPlaying = true;
  }

  onPause() {
    console.log('bgm is stopped');
    this.isPlaying = false;
  }

  togglePlay() {
    const playBtn = this.$refs.playBtn as HTMLDivElement;
    const player = this.$refs.player as HTMLAudioElement;

    // playBtn.style.animationPlayState = this.isPlaying ? 'paused' : 'running';
    if (this.isPlaying) {
      player.pause();
    } else {
      player.play();
    }
    this.isPlaying = !this.isPlaying;
  }
}
